export const getTheme = () => {
    const theme = localStorage.getItem("theme");
    return theme==="2" ? true : false;
  };